import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/long-arrow-down.svg';
import _imports_1 from '@/assets/images/icons/loading.svg';
import _imports_2 from '@/assets/images/icons/open.svg';
import _imports_3 from '@/assets/images/icons/link.svg';
const _withScopeId = n => (_pushScopeId("data-v-1cd122fa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "d-flex justify-content-center",
  style: {
    "margin-top": "-8px",
    "margin-bottom": "-8px"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "down-class"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 1,
  class: "down-class"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading-load",
  src: _imports_1,
  style: {
    "width": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "d-flex align-items-center"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "18px"
  },
  alt: ""
}, null, -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  key: 0,
  class: "err-tip"
};
const _hoisted_12 = {
  key: 1,
  class: "mt-3"
};
const _hoisted_13 = {
  class: "link-text",
  style: {
    "text-decoration": "underline",
    "color": "rgb(77, 56, 0)"
  },
  target: "_blank",
  href: "https://docs.filecoin.io/smart-contracts/filecoin-evm-runtime/differences-with-ethereum/#bare-value-sends"
};
const _hoisted_14 = {
  class: "mt-3"
};
const _hoisted_15 = {
  key: 0,
  class: "err-tip"
};
const _hoisted_16 = {
  class: "mt-3 d-flex align-items-center"
};
const _hoisted_17 = {
  key: 0,
  class: "ml-2 cursor-pointer icon-hover"
};
const _hoisted_18 = {
  class: "mt-3 d-flex align-items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_transfer_input = _resolveComponent("transfer-input");
  const _component_evm_tip = _resolveComponent("evm-tip");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [!$data.checkAddressLoading ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true), $data.checkAddressLoading ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(_component_transfer_input, {
    ref: "transfer-textarea",
    modelValue: $data.stFilForm.to,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.stFilForm.to = $event),
    onInput: $options.toAddressChangeWait,
    title: _ctx.$t('transfer.to'),
    id: "2",
    disabled: $data.loading,
    placeholder: "0x f0 f1 f2 f3 f4",
    type: "textarea",
    showValueTip: $data.formToEthAddress !== '',
    "value-tip": $data.formToEthAddress,
    valueFontSize: "20px"
  }, {
    subTitle: _withCtx(() => [_createElementVNode("div", _hoisted_8, [$data.formFinish.to ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "mr-2",
      onClick: _cache[0] || (_cache[0] = $event => $options.gotoAdr($data.stFilForm.to))
    }, _hoisted_10)) : _createCommentVNode("", true), $data.stFilForm.to !== '' && $data.stFilForm.to.length > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "icon-hover",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.clearInputTo && $options.clearInputTo(...args))
    }, _toDisplayString(_ctx.$t('common.clear')), 1)) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["modelValue", "onInput", "title", "disabled", "showValueTip", "value-tip"]), $data.toErrTips !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($data.toErrTips), 1)) : _createCommentVNode("", true), $data.isEvm ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_evm_tip, null, {
    content: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("transfer.contractTipContent")), 1), _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t("stake.LearnMore")), 1)]),
    _: 1
  })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_transfer_input, {
    title: _ctx.$t('transfer.amount'),
    onInput: $options.amountChange,
    modelValue: $data.stFilForm.amount,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.stFilForm.amount = $event),
    type: "number",
    disabled: $data.loading,
    placeholder: "0.00",
    showValueTip: $data.showAmountUsd,
    valueTip: `≈ $${$data.amountUsd}`
  }, {
    subTitle: _withCtx(() => [_createElementVNode("span", {
      onClick: _cache[3] || (_cache[3] = (...args) => $options.setAmountIsBalance && $options.setAmountIsBalance(...args)),
      class: "icon-hover"
    }, _toDisplayString(`${_ctx.$t('transfer.balance')}: ${$options.formatWalletFilPrice(_ctx.stFilBalance, 2, true)}`), 1)]),
    _: 1
  }, 8, ["title", "onInput", "modelValue", "disabled", "showValueTip", "valueTip"]), $data.amountErrTips !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($data.amountErrTips), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_button, {
    disabled: !_ctx.ifAllFinishSend,
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    style: {
      "border-radius": "50px!important"
    },
    onClick: $options.send
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : _ctx.$t('transfer.send')), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"]), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("img", {
    onClick: _cache[5] || (_cache[5] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_3,
    alt: ""
  })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    style: {
      "border-radius": "50px!important"
    },
    disabled: $data.loading,
    onClick: $options.clearInput
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('transfer.clear')), 1)]),
    _: 1
  }, 8, ["disabled", "onClick"])])]);
}